import LazyLoadImg from "components/LazyLoadImg";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { RouteName } from "constant/routeNames";
import { useNavigate } from "react-router-dom";
import AddPodcastToFav from "./AddPodcastToFav";
import { useSelector } from "react-redux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaCrown } from "react-icons/fa";
import { ContentType } from "services/subscription/types";
import { usePremiumAccess } from "hooks/usePremiumAccess";
import PremiumContentModal from "components/PremiumContentModal";

function Podcastcard({ podcast, user, is_creator }: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const { isModalOpen, setIsModalOpen, checkAccess } = usePremiumAccess();
  const navigate = useNavigate();

  const isPremiumContent = podcast?.plan_id === 2;
  const isPlusUser = loggedInUser?.is_subscribed;

  const handleCardClick = async () => {
    const access = await checkAccess({
      contentType: ContentType.PODCASTS,
      id: podcast?.id,
      isPremiumContent,
      isCreator: is_creator,
    });
    if (!access) return;

    navigate(RouteName.PodcastOpenEpisodeRoute.replace(":id", podcast.id));
  };

  const packageObject: any = {
    id: podcast?.service_id || podcast?.id,
    entitlement_id: podcast?.entitlement_id || "",
    title: podcast?.title,
    price: podcast?.price || "",
    thumbnail: podcast?.artwork_url || "",
    created_at: podcast?.created_at || "",
    description: podcast?.description || "",
    is_subscribed: podcast?.is_subscribed || false,
    role_id: podcast?.plan_id,
    slug: podcast?.slug,
  };

  return (
    <>
      <PremiumContentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCreator={is_creator}
        packageObject={packageObject}
      />

      <div
        onClick={handleCardClick}
        className="group mb-[15px] block w-full cursor-pointer rounded-xl p-1.5 shadow-lg transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-slate-800 hover:shadow-xl"
        role="button"
        tabIndex={0}
      >
        <div className="bg-img white-text relative aspect-square w-full overflow-hidden rounded-lg ring-1 ring-white/5 transition-all duration-300 group-hover:ring-2 group-hover:ring-[var(--red)]/40">
          <LazyLoadImg
            imgSrc={podcast.artwork_url}
            imgAlt={podcast?.title}
            imgHeight={"100%"}
            imgWidth={"100%"}
            wrapperProps={{
              style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                display: "block",
              },
            }}
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />

          {/* Premium pill */}
          {isPremiumContent && (
            <div className="absolute left-2 top-2 z-10 flex items-center gap-1 rounded-full border border-white/15 bg-black/40 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-lg backdrop-blur-md">
              <FaCrown className="text-[10px] text-[var(--red)]" />
              <span>Premium</span>
            </div>
          )}

          <div
            className="absolute inset-x-0 bottom-0 mb-3 flex justify-end p-2"
            onClick={(e) => e.stopPropagation()}
          >
            {loggedInUser && user?.id === loggedInUser.id && (
              <AddPodcastToFav podcast={podcast} podcastCard={true} />
            )}
          </div>
        </div>

        <div className="relative top-1 mb-4 h-[60px]">
          <div className="my-[4px]">
            <p
              className="text-[14px] font-[600] leading-tight text-white transition-colors group-hover:text-white"
              data-tooltip-id={
                podcast?.title?.length > 28
                  ? `add-song-to-favorite-${podcast?.id}`
                  : ""
              }
            >
              {decodeHtmlEntities(podcast?.title?.replace(/_/g, " ")).length > 28
                ? `${decodeHtmlEntities(podcast?.title?.replace(/_/g, " ")).slice(0, 28)}...`
                : decodeHtmlEntities(podcast?.title?.replace(/_/g, " "))}
            </p>

            <div className="text-sm">
              <ReactTooltip
                id={`add-song-to-favorite-${podcast?.id}`}
                place="top"
                content={podcast?.title}
                style={{ width: "180px" }}
              />
            </div>

            <div className="absolute mb-0">
              <p className="mt-[5px] w-[165px] text-[11px] font-[400] leading-tight text-white/60 hover:text-zinc-100">
                {decodeHtmlEntities(podcast.artist?.name)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Podcastcard;